// Lib
import { FC, useCallback, useState } from "react";
// Hooks
import { useViewport } from "hooks";
// Icons
import { ReportsIcon } from "icons";
// Components
import { ConfirmDialog } from "components/Modals";
// Styled
import { Button } from "styled/Buttons";

interface ReportProps {
  isLoading?: boolean;
  handleCreateReport: () => Promise<void>;
}

export const Report: FC<ReportProps> = ({ isLoading, handleCreateReport }) => {
  const { isMobile } = useViewport();

  const [isConfirm, setIsConfirm] = useState(false);

  const onConfirm = useCallback(() => {
    handleCreateReport();
    setIsConfirm(prev => !prev);
  }, [handleCreateReport]);

  return (
    <>
      {isMobile ? (
        <Button.SquaredIcon
          loading={isLoading}
          icon={<ReportsIcon />}
          onClick={() => setIsConfirm(prev => !prev)}
        />
      ) : (
        <Button.SubHeading
          loading={isLoading}
          icon={<ReportsIcon />}
          onClick={() => setIsConfirm(prev => !prev)}
        >
          Report
        </Button.SubHeading>
      )}

      <ConfirmDialog
        isLoading={isLoading}
        open={isConfirm}
        Icon={ReportsIcon}
        message="Report creating"
        description="Report will be created according to selected table filters. Are you sure you want to continue?"
        onCancel={() => setIsConfirm(prev => !prev)}
        firstCTAButton={{
          type: "primary",
          title: "Create Report",
          onClick: onConfirm,
        }}
      />
    </>
  );
};
